import { StackPullRequestItem } from "shared/Stack/useStackPullRequests/gql";

import { isStackPullRequestExpandable } from "../helpers";
import { StackPullRequestsTableChildRow } from "./Cells/types";

type StackPullRequestsTableFlatRow =
  | {
      kind: "parent";
      pullRequest: StackPullRequestItem;
      isExpandable: boolean;
      isExpanded: boolean;
    }
  | StackPullRequestsTableChildRow;

export const getStackPullRequestsTableExpandedRowKey = (stackId: string, pullRequestId: string) =>
  `${stackId}:${pullRequestId}`;

export const flattenStackPullRequestsTableRows = (
  stackId: string,
  pullRequests: StackPullRequestItem[],
  expandedRows: Set<string>
) => {
  const rows: StackPullRequestsTableFlatRow[] = [];
  const stickyRanges: [number, number][] = [];

  for (const pullRequest of pullRequests) {
    const isExpandable = isStackPullRequestExpandable(pullRequest.runs);
    const isExpanded =
      isExpandable &&
      expandedRows.has(getStackPullRequestsTableExpandedRowKey(stackId, pullRequest.id));
    const parentIndex = rows.length;

    rows.push({ kind: "parent", pullRequest, isExpandable, isExpanded });

    if (!isExpanded) {
      continue;
    }

    const runsNewestFirst = [...pullRequest.runs].sort((a, b) => b.createdAt - a.createdAt);

    for (const run of runsNewestFirst) {
      rows.push({ kind: "child", pullRequest, run });
    }

    stickyRanges.push([parentIndex, rows.length - 1]);
  }

  return { rows, stickyRanges };
};
